import { vaultRequest } from './request';

const GET_OWNERS_BY_ORG_ID_QUERY = `
query VaultOwners($orgId: ID!) {
  vaultOwners(orgId: $orgId) {
    id
    createdAt
    updatedAt
    kycId
    orgId
    financialAccountId
    stripeConnectAccountId
    stripePersonId
  }
}
`;

export const getOwnersByOrgId = async (orgId: string): Promise<Owner[]> => {
  const ownersRes = await vaultRequest(GET_OWNERS_BY_ORG_ID_QUERY, {
    orgId,
  });
  const ownersData = await ownersRes.json();
  if (ownersData.errors) {
    throw new Error(ownersData.errors.map((e: Error) => e.message).join('. '));
  }
  return ownersData.data.vaultOwners;
};
